import { useDBTInterruptActions } from "../../../../store/useDBTInterruptStore";
import { useSessionActions } from "../../../../store/useSessionStore";
import {
  DBTCommitModelsKwargs,
  DBTQuerySelectionKwargs,
  InterruptType,
} from "../../../types";
import {
  transformFieldsToCommitModelsConfig,
  transformFieldsToDBTConfig,
  transformFieldsToQuerySelectionConfig,
} from "../../Interrupts/DBT/transformers";

const useInterrupt = () => {
  const { setInterruptAction } = useSessionActions();
  const {
    setDBTGithubConfig,
    setDBTQuerySelectionConfig,
    setDBTCommitModelsConfig,
  } = useDBTInterruptActions();

  const handleInterrupt = (interruptValue: InterruptType) => {
    setInterruptAction(interruptValue.action);

    switch (interruptValue.action) {
      case "DBT-github_credentials":
        setDBTGithubConfig(transformFieldsToDBTConfig(interruptValue.fields));
        break;

      case "DBT-query_selection":
        setDBTQuerySelectionConfig(
          transformFieldsToQuerySelectionConfig(
            interruptValue.fields,
            interruptValue.additional_kwargs as DBTQuerySelectionKwargs
          )
        );
        break;

      case "DBT-commit_models":
        setDBTCommitModelsConfig(
          transformFieldsToCommitModelsConfig(
            interruptValue.fields,
            interruptValue.additional_kwargs as DBTCommitModelsKwargs
          )
        );
        break;

      default:
        console.warn(`Unknown DBT interrupt action: ${interruptValue.action}`);
    }
  };

  return {
    handleInterrupt,
  };
};

export default useInterrupt;
